import {NgModule} from '@angular/core';
import {CamJobModule} from "./job/camJob.module";
@NgModule({
    imports: [
        CamJobModule
    ]
})
export class CamModule {}

